import styles from './Setting.module.scss'
import { useState } from 'react';
import { getLangName as t } from '../utils/index'
import bgPng from '../assets/images/bg.png';
import u110 from '../assets/images/home/u110.png'
function Settings() {
  const [key, seyKEy] = useState('1'); // 定义一个状态变量，用于控制当前选中的标签页
  return <>
    <div className={styles.settings}>
      <div className={styles.bg}>
        <div className={styles.bgTxt}>
          <span className={styles.bgTxtCn}>新闻中心</span>
          <span className={styles.bgTxtEn}>NEWS</span>
        </div>
        <img src={bgPng} alt="" />
      </div>
      <div className={styles.newsBox}>
        <div className={styles.newsBox_tab}>
          <div className={
            key === '1' ? styles.newsBox_tab_item_active : styles.newsBox_tab_item
          } onClick={() => seyKEy('1')}>{t('CompanyNews')}</div>
          <div className={

            key === '2' ? styles.newsBox_tab_item_active : styles.newsBox_tab_item
          } onClick={() => seyKEy('2')}>{t('IndustryNews')}</div>
        </div>
      </div>
      <div className={styles.newsContent}>
      <div className={styles.newsContent_item}>
          <img className={styles.newsContent_item_img} src={u110} />
          <div className={styles.newsContent_item_box}>
            <div className={styles.newsContent_item_box_title}>
              <div className={styles.nasdsd}>{t('ImmersiveTechTitle')}</div>
              <div className={styles.datesss}>2025-02-27</div>
            </div>
            <div className={styles.csdadas}> 
              {t('ImmersiveTechDesc')}
            </div>
          </div>
        </div>
        <div className={styles.newsContent_item}>
          <img className={styles.newsContent_item_img} src={u110} />
          <div className={styles.newsContent_item_box}>
            <div className={styles.newsContent_item_box_title}>
              <div className={styles.nasdsd}>{t('ImmersiveTechTitle')}</div>
              <div className={styles.datesss}>2025-02-27</div>
            </div>
            <div className={styles.csdadas}> 
              {t('ImmersiveTechDesc')}
            </div>
          </div>
        </div>
        <div className={styles.newsContent_item}>
          <img className={styles.newsContent_item_img} src={u110} />
          <div className={styles.newsContent_item_box}>
            <div className={styles.newsContent_item_box_title}>
              <div className={styles.nasdsd}>{t('ImmersiveTechTitle')}</div>
              <div className={styles.datesss}>2025-02-27</div>
            </div>
            <div className={styles.csdadas}> 
              {t('ImmersiveTechDesc')}
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
}

export default Settings;